import React from 'react';

import * as Form from 'components/form';

export function LoginValidateForm(props) {
    const { form, onSubmit } = props;

    // Create form fields object
    const fields = {
        email: {
            autoComplete: 'email',
            autoFocus: true,
            error: form.errors.email,
            label: props.t('glossary:workEmail'),
            name: 'email',
            type: 'email',
            value: form.values.email,
            onChange: form.handleChange,
        },
        pincode: {
            autoComplete: 'one-time-code',
            autoFocus: true,
            error: form.errors.pincode,
            label: props.t('glossary:pincode'),
            name: 'pincode',
            maxLength: 6,
            type: 'pincode',
            value: form.values.pincode,
            onChange: form.handleChange,
        },
    };

    // Handle form submition
    const evSubmit = ev => form.handleSubmit(ev, onSubmit);
    return (
        <Form.Form name="LoginValidateForm" onSubmit={evSubmit}>
            <Form.Field {...fields.email} />
            <Form.Field {...fields.pincode} />
            <Form.Submt {...form} text={props.t('glossary:continue')} />
        </Form.Form>
    );
}
export default LoginValidateForm;
